<template>
    <section class="formatter">
        <div class="d-flex gap-5 groups">
            <TimezonePickerInput v-model="clone.isBetween.fromTimezone" title="First Date Timezone" />
            <TimezonePickerInput v-model="clone.isBetween.toTimezone" title="Others Date Timezone" />
        </div>
        <div class="d-flex gap-5 groups">
            <FormatPickerInput v-model="clone.isBetween.fromFormat" title="First Date Format" />
            <FormatPickerInput v-model="clone.isBetween.toFormat" title="Others Date Format" />
        </div>
        <div class="d-flex gap-5 groups">
            <LocalePickerInput v-model="clone.isBetween.fromLocale" title="First Date Locale" />
            <LocalePickerInput v-model="clone.isBetween.toLocale" title="Others Date Locale" />
        </div>
        <div class="d-flex gap-5">
            <div class="editor-row customize-editor-minimize">
                <div class="editor-row-title">{{ $t('auto.dateIsBetweenIncludeBoundaries') }}</div>
                <a-switch v-model="clone.isBetween.inclusive" />
            </div>
        </div>
    </section>
</template>

<script>
import _ from "lodash";
import log2 from "../../../../../../../../../utils/log2";
import TiptapEditor from "../../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import FormatPickerInput from "../inputs/FormatPickerInput.vue";
import LocalePickerInput from "../inputs/LocalePickerInput.vue";
import TimezonePickerInput from "../inputs/TimezonePickerInput.vue";

const log = log2("DateIsBetween.vue");
export default {
    name: "DateIsBetween",
    components: { TiptapEditor, FormatPickerInput, LocalePickerInput, TimezonePickerInput },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "date.isBetween",
            inputs: ["", "", ""],
            isBetween: {
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                fromTimezone: "UTC",
                toTimezone: "UTC",
                fromLocale: "en",
                toLocale: "en",
                inclusive: true
            }
        };
        if (!clone.isBetween) {
            clone.isBetween = {
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                fromTimezone: "UTC",
                toTimezone: "UTC",
                fromLocale: "en",
                toLocale: "en",
                inclusive: true
            };
        }
        return {
            clone
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            }
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        }
    }
};
</script>

<style lang="scss" scoped>
section.formatter {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;

    .groups {
        width: 100%;
        display: flex;
        gap: 5px;
        justify-content: space-between;

        .format-picker-section,
        .locale-picker-section,
        .timezone-picker-section {
            width: 100%;
        }
    }
}
</style> 